import { gql } from "@/gql";

export const GET_DISCOUNT_COHORT_MATRICES = gql(`
  query GetDiscountCohortMatrices(
    $franchiseId: ID!
    $acquisitionYear: Int
  ) {
    discountCohortMatrices(
      franchiseId: $franchiseId
      acquisitionYear: $acquisitionYear
    ) {
      generatedAt
      discount {
        type
        rows {
          cohortStart
          cohortSize
          cells {
            monthIndex
            activeCount
            retentionRate
            revenueGenerated
          }
        }
      }
      nonDiscount {
        type
        rows {
          cohortStart
          cohortSize
          cells {
            monthIndex
            activeCount
            retentionRate
            revenueGenerated
          }
        }
      }
    }
  }
`);
